export default __webpack_public_path__ + "static/media/general_b_eng.89b6347a.png";